import { useMemo } from 'react';

import { TableCell } from '@mui/material';

import { RunConfigStatus } from 'src/utils/enumerations';

import { Label } from 'src/components/label';

const StatusLabelCell: React.FC<{ runConfigStatus: RunConfigStatus }> = ({ runConfigStatus }) => {
  const labelVariant = useMemo(() => {
    if (runConfigStatus === RunConfigStatus.Completed) return 'success';
    if (runConfigStatus === RunConfigStatus.Failed) return 'error';
    return 'default';
  }, [runConfigStatus]);

  return (
    <TableCell>
      <Label color={labelVariant} variant="soft">
        {runConfigStatus}
      </Label>
    </TableCell>
  );
};

export default StatusLabelCell;
